import React, { useState } from "react";
import { useSelector } from "react-redux";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const TabMenuWrapper = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

const StyledNavbar = styled(Navbar)`
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
`;

const StyledNav = styled(Nav)`
  .nav-link {
    color: #5a5a5a;
    font-weight: 500;
    &.active {
      color: #0c8de3;
    }
  }
`;

const SubMenu = styled.div`
  .nav-link {
    padding-left: 20px;
  }
`;

export const TabMenu = () => {
  const accesos = useSelector((state) => state.accesos);

  const renderSubMenu = (items, parentUrl) => {
    console.log('url', parentUrl);
    return items.map((item, index) => (

      <Nav.Link as={NavLink} key={index} to={`${parentUrl}/${item.url}`}>
        {item.nombre}
      </Nav.Link>
    ));
  };

  const renderMenu = () => {
    return accesos?.map((op, index) => {
      
      if (op.children && op.children.length > 0) {
        return (
          <div key={index}>
            <Nav.Link as={NavLink} to={`${op.url}`} className="font-weight-bold">{op.nombre}</Nav.Link>
            <SubMenu>
              {renderSubMenu(op.children, op.url)}
            </SubMenu>
          </div>
        );
      } else {
        return (
          <Nav.Link as={NavLink} key={index} to={`${op.url}`}>
            {op.nombre}
          </Nav.Link>
        );
      }
    });
  };

  return (
    <TabMenuWrapper>
      <StyledNavbar expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <StyledNav className="mr-auto">
            {renderMenu()}
          </StyledNav>
        </Navbar.Collapse>
      </StyledNavbar>
    </TabMenuWrapper>
  );
};